import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Quicklink } from "./quicklink.model";

const ACTION_PREFIX = "[Quicklink]";
export const QUICKLINK_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,
};

/**
 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class QuicklinkAction {
	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	get(): Action {
		return createCachedGetAction({
			type: QUICKLINK_ACTION_TYPE.get,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	getSuccess(quicklinks: Record<string, Quicklink[]>): ActionWithPayload {
		return createGetSuccessAction({
			type: QUICKLINK_ACTION_TYPE.getSuccess,
			payload: quicklinks,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	getFail(error: AppError): ActionWithPayload {
		return {
			type: QUICKLINK_ACTION_TYPE.getFail,
			payload: error,
		};
	}
}
